import { _ } from "../../../polyglot/polyglot.js";
import { formatAsMonthAndYear } from "../../../helpers/date-formatting-util.js";
import AbstractFormStep from "../../AbstractFormStep.js";

/**
 * The step to choose various import options for Quickbooks.
 */
export default class ImportOptionsSelectionStep extends AbstractFormStep {
	constructor() {
		super(...arguments);
		this._canGoToPreviousStep = false;
	}

	_populateForm(form) {
		const items = this._context.fiscalYears.map((item) => ({
			label: `${formatAsMonthAndYear(
				item.start,
			)} - ${formatAsMonthAndYear(item.end)}`,
			value: item,
		}));

		this._dropdown = form.newDropDownField({
			items,
			label: _("Fiscal year"),
			attribute: "fiscalYear",
			name: "select-fiscal-year",
			dataTestName: "select-item",
			liveSearch: true,
		});

		this._switchItem = form.switchButton({
			name: "switch-button-import-attachments",
			attribute: "importAttachments",
			label: _("Include attached documents"),
		});
	}
}
